<template>
  <ControlWrapper v-bind="controlWrapper" :styles="styles" :is-focused="isFocused" :applied-options="appliedOptions">
    <SectionWrapper id="license-plate-confirm" class="flex flex-col">
      <template #header>
        <div class="flex w-full items-center justify-between" :class="styles.control.label">
          <h3>
            {{ computedLabel }}
          </h3>
        </div>
      </template>
      <div class="flex w-full flex-col">
        <WInput
          v-model="newVin"
          type="text"
          name="vin"
          :error="vinError || control.errors?.replace('is a required property', 'This field is required') || ''"
          :label="inputLabel"
          @update:model-value="setVin"
        />
      </div>
    </SectionWrapper>
  </ControlWrapper>
</template>

<script lang="ts" setup>
  import { ControlElement } from '@jsonforms/core';
  import { computed, nextTick, ref } from 'vue';
  import { rendererProps, useJsonFormsControl } from '@jsonforms/vue';
  import { useWidgetControl } from '../util';
  import SectionWrapper from 'components/claims-widget/components/SectionWrapper.vue';
  import ControlWrapper from './ControlWrapper.vue';
  import WInput from '../../base/Input.vue';
  import { useDebounceFn } from '@vueuse/core';

  interface VinOptions {
    editIcon?: string;
    deleteIcon?: string;
    confirm?: string;
    noOp?: string;
    label?: string;
  }

  const props = defineProps({
    ...rendererProps<ControlElement>(),
  });
  const { control, controlWrapper, styles, isFocused, appliedOptions, onChange, computedLabel } = useWidgetControl(
    useJsonFormsControl(props)
  );

  const vinOptions = ref((control.value.schema as unknown as { vinSection: VinOptions }).vinSection);
  const vinError = ref('');
  const inputLabel = computed(() => vinOptions.value.label);

  const newVin = ref('');

  const submitVin = useDebounceFn(() => {
    onChange(newVin.value);
  }, 500);

  submitVin();

  function setVin(vin: string) {
    nextTick(() => {
      newVin.value = vin.toUpperCase().trim();
      const rgx = new RegExp('[^a-zA-Z0-9]', 'g');
      newVin.value = String(newVin.value).replaceAll(rgx, '');

      if (vin.length > 17) {
        newVin.value = vin.slice(0, 17);
      }
      if (/[A-HJ-NPR-Z0-9]{17}/i.test(newVin.value)) {
        vinError.value = '';
        submitVin();
        return;
      }

      vinError.value = 'Must be a valid VIN';
    });
  }
</script>
